import styled from 'styled-components'

// Components
import Button from 'components/Button'
import Link from 'components/Link'

export const StyledButton = styled(Button)`
  width: 100%;
  margin: 0 auto;
`
export const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  margin-top: 24px;
  text-align: center;
`
